import {Inject} from '@angular/core';
import { BaseEntity } from '../base/BaseEntity';
import { Observable } from 'rxjs';
import { CrudOperations } from '../interfaces/crudOperations';
import { HttpClient } from '@angular/common/http';
import { DocumentBaseService } from './document-base.service';
import { IQueryResult } from '../base/interfaces/IQueryResult';

export class HistoryBaseService<T extends BaseEntity> extends DocumentBaseService<T> {

    data;
    observable;
    singularEndpoint: string;

     constructor(
        protected http: HttpClient,
        protected rootUrl: string,
        protected endpoint: string,
        protected singular: string = null
    ) {
        super(http, rootUrl, endpoint, singular);
    }
    GetAllByParent(id: string,
        sort: string = null, sortOrder: string = null, page: number = 0, pageSize: number = 0): Observable<IQueryResult<T>> {
            const params = {};
            params['$top'] = pageSize || 50;
            if (page) {
              params['$skip'] = (page - 1) * params['$top'];
            }
            if (sort) {
              params['$orderby'] = sort.toString();
              if (sortOrder) {
                params['$orderby'] += ` ${sortOrder}`;
              }
            }

        return this.http.get<IQueryResult<T>>(`${this.rootUrl}/${this.endpoint}/Parent/${id}`, {params: params});
    }
}
